var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prev-next-nav"},[_c('div',{staticClass:"prev"},[(_vm.previousPage)?_c('router-link',{staticClass:"icon-arrow-left",attrs:{"to":{
        name: _vm.previousPage.type,
        params: { slug: _vm.$route.params.slug, subSlug: _vm.previousPage.slug }
      }}},[_vm._v(" "+_vm._s(_vm.previousPage.name)+" ")]):_vm._e()],1),_c('div',{staticClass:"next"},[(_vm.nextPage)?_c('router-link',{staticClass:"icon-arrow-right-after",attrs:{"to":{
        name: _vm.nextPage.type,
        params: { slug: _vm.$route.params.slug, subSlug: _vm.nextPage.slug }
      }}},[_vm._v(" "+_vm._s(_vm.nextPage.name)+" ")]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }